<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Crear Emision</v-toolbar>
        <v-card-text>
          <v-container class="mt-1" v-if="!loading">
            <v-select
              v-model="item.tipoDocumentoSector"
              :items="docssector"
              label="Documento Sector:"
              :disabled="loading"
              item-value="id"
              class="mt-4"
              outlined
              dense
              hide-details
            />
          </v-container>

          <v-progress-linear class="mt-4" indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="registrar()" :disabled="loading" class="green" dark>Emitir Evento Masivo</v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        loadingtipoDocumentoSector: false,
        msg: '',
        tdocs: [],
        docssector: [
          { id: 1, text: 'COMPRA Y VENTA' },
          { id: 11, text: 'SECTOR EDUCATIVO' },
        ],
        item: {
          cafc: 'string',
          eventoID: 0,
          tipoDocumentoSector: 0,
        },
      };
    },
    components: {},
    methods: {
      openmodal(item) {
        this.msg = '';
        this.dialog = true;
        this.item.eventoID = item.id;
        window.console.log(item);
        this.item.tipoDocumentoSector = null;
        //this.getdocumentos();
      },
      getdocumentos() {
        let vue = this;
        this.loadingtipoDocumentoSector = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/tiposdocumentos`,
          headers: {
            'Content-Type': 'application/json',
            //apikey: '4265269017',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.map((x) => {
              x.codigo = parseInt(x.codigo_clasificador_SIN);
              x.text = `${x.codigo_clasificador_SIN} (${x.descripcion_SIN})`;
            });
            vue.tdocs = data;
            vue.loadingtipoDocumentoSector = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingtipoDocumentoSector = false;
          });
      },
      verificarsector() {
        let vue = this;
        vue.loading = true;
        this.msg = `Verificando documento sector...`;
        let ev = {
          envioMasivoID: this.item.eventoID,
          tipoDocumentoSector: this.item.tipoDocumentoSector,
        };
        var config = {
          method: 'post',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/emision/masivo/verificar/documentosector`,
          headers: {
            apikey: this.$store.getters.getApiKey,
            'Content-Type': 'application/json',
          },
          data: ev,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('verificarsector:', data);
            vue.loading = false;
            vue.msg = '';
            vue.registrar();
          })
          .catch(function(error) {
            window.console.log(error.response);
            vue.loading = false;
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data);
            if (mensaje || data.detalles) vue.msg = `Error ${mensaje}`;
            else vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;
          });
      },
      registrar() {
        this.msg = '';
        if (!this.item.tipoDocumentoSector) {
          this.msg = 'Seleccione un tipo documento sector.';
          return;
        }
        let vue = this;
        vue.loading = true;
        this.msg = 'Emitiendo masivo....';
        var config = {
          method: 'post',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/emision/masivo/documentosector`,
          headers: {
            apikey: this.$store.getters.getApiKey,
            'Content-Type': 'application/json',
          },
          data: this.item,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('registrar masivo:', data);
            vue.loading = false;
            vue.msg = '';
            if (data.envio) {
              vue.msg = `Cod. recep: ${data.envio.codigoRecepcion} - ${data.envio.codigodescripcion}`;
            }
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data);
            if (mensaje || data.detalles) vue.msg = `Error ${mensaje}`;
            else vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;
          });
      },
    },
  };
</script>
